<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div>
            <slot />
          </div>
        </div>
        <Footer />
        <div class="px-5">
          <b-card>
            <div>
              <h3 v-if="test" class="text-primary">
                {{test.test.title}}
              </h3>
              <div v-for="(question, index) in questions" :key="index"
                   class="w-100 mt-4" :id="question.id">
                <div class="font-size-18">
                  <strong>
                    {{index+1}}. {{question.question}}
                  </strong>
                </div>
                <div class="w-100 mt-4">
                  <div v-for="(answer, aIndex) in question.answers" :key="aIndex" class="mt-3">
                    <div class="d-flex">
                      <i class="bx bx-check-circle font-size-20" :class="getAnswerStatus(answer,question.answer)"></i>
                      <span class="ms-2">
                        {{answer.answer}}
                      </span>
                    </div>
<!--                    <b-form-group>-->
<!--                      <b-form-radio-->
<!--                          v-model="question.answer"-->
<!--                          class="mb-3"-->
<!--                          :value="answer.id"-->
<!--                          plain-->
<!--                      ><span class="font-size-16">{{answer.answer}}</span></b-form-radio>-->
<!--                    </b-form-group>-->
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getTestByAnswers} from "../../../../../../api/tests";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";

export default {
  name: "TestAnswers",
  components: {
    HorizontalTopbarInside, SideBar
  },
  computed: {
    ...layoutComputed,
  },
  data() {
    return {
      test: null,
      questions: [],
    }
  },
  created ()  {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchTest()
  },
  methods: {
    fetchTest(){
      getTestByAnswers({test_id: this.$route.params.testId}).then(res => {
        this.questions = res.data.data.test.questions;
        this.test = res.data.data;
      })
    },
    getAnswerStatus(answer,qAnswer) {
        if(!qAnswer) {
          if(answer.is_correct) {
            return 'bx-check-circle'
          }
          else {
            return 'bx-circle'
          }
        }
        else {
          if(qAnswer === answer.id) {
            return answer.is_correct ? 'bx-check-circle text-success' : 'bx-minus-circle text-danger';
          }
          else {
            return !answer.is_correct ? 'bx-circle' : 'bx-check-circle text-success';
          }
        }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },

}
</script>

<style scoped>

</style>
